import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { drapcodeIcon } from '../../common/custom/icon-library';
import {
  menuItemsForSnapshot,
  getAppSettingBasePath,
  isAppSettingActive,
} from '../../common/utils/api_utils';

const SnapshotMenu = () => {
  const { pathname } = useLocation();
  const { projectId, version } = useParams();

  const dropdownColor = menuItemsForSnapshot.some((item) =>
    isAppSettingActive(pathname, item.key, version, projectId),
  )
    ? 'theme-green--dropdown'
    : 'theme-primary--dropdown';

  return (
    <UncontrolledDropdown group className="ml-2">
      <DropdownToggle color={dropdownColor} title="Snapshots" className="btn-md" caret>
        <i className={`wb ${drapcodeIcon('snapshots')}`}></i> Snapshots
      </DropdownToggle>
      <DropdownMenu>
        {menuItemsForSnapshot.map((item) => {
          const to = getAppSettingBasePath(item.key, version, projectId);
          const activeClass = isAppSettingActive(pathname, item.key, version, projectId)
            ? 'active'
            : '';
          return (
            <DropdownItem
              key={item.key}
              tag={Link}
              to={to}
              className={`theme-primary ${activeClass}`}
            >
              <i className={`wb ${drapcodeIcon(item.icon)}`}></i>&nbsp;{item.label}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default SnapshotMenu;
